import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingActivityEditCompletePage } from './jacking-activity-edit-complete';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    JackingActivityEditCompletePage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingActivityEditCompletePage),
  ],
})
export class JackingActivityEditCompletePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-edit-complete/jacking-activity-edit-complete.module.ts